import React, { Component } from 'react';
import { connect } from 'react-redux';

import Aux from 'hoc/ReactAux/ReactAux';
import ReactModal from 'react-modal';
import ModalError from '../../../../../components/UI/Modal/ModalError';
import currencyUtils from 'utils/currency';
import * as menuActions from '../../../../../store/actions';
import PickOutOptions from './PickOutOptions';
import NutritionFacts from '../ProductDetails/NutritionFacts';
import './ProductDetails.css';
import { ERROR_CODES, knownError } from 'utils/userError';

const initialState = {
  total: 0,
  errorMessage: '',
  showModal: false,
  mealOptions: [],
};

const customStyles = {
  overlay: {
    zIndex: '9999999',
    width: '100%',
    maxHeight: document.documentElement.clientHeight < 900 ? '100%' : '540px',
    left: '0',
    top: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
};

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.productSelected !== prevProps.productSelected &&
      this.props.productSelected
    ) {
      this.setState({ total: this.props.productSelected.price });
    }
  }

  handleSelectMealOptions = (evt, idCategoryType, idMealOption) => {
    let category = this.props.productSelected.mealOptions.find(
      x => x.idCategoryType === idCategoryType
    );
    let mealOption = category.mealOptionItens.find(x => x.id === idMealOption);
    if (evt.target.checked) {
      let mealOptionsUpdated = [...this.state.mealOptions];

      let list = mealOptionsUpdated.filter(item => {
        return item.idCategoryType === idCategoryType;
      });
      if (
        !!!category.itemMaxQuantity ||
        list.length < category.itemMaxQuantity
      ) {
        mealOptionsUpdated.push({
          idCategoryType: idCategoryType,
          idMealOption: idMealOption,
          price: mealOption.price,
        });
        this.setState({ mealOptions: mealOptionsUpdated });
        let totalProduct = this.state.total + mealOption.price;
        this.setState({ total: totalProduct });
      } else {
        const max = category.itemMaxQuantity;
        this.setState({
          showModal: true,
          errorMessage: knownError(ERROR_CODES.MENU_OPTIONS_MAX, {
            title: `You can choose up to ${max} here`,
            message: `This section allows ${max} ${max === 1 ? 'choice' : 'choices'}.`,
            guidance: 'Untick one to choose a different option.',
          }),
        });
      }
    } else {
      let totalProduct = this.state.total - mealOption.price;
      this.setState({ total: totalProduct });
      let index = this.state.mealOptions.findIndex(
        x =>
          x.idCategoryType === idCategoryType && x.idMealOption === idMealOption
      );
      let mealOptionsUpdated = [
        ...this.state.mealOptions.slice(0, index),
        ...this.state.mealOptions.slice(index + 1),
      ];
      this.setState({ mealOptions: mealOptionsUpdated });
    }
  };

  handleClickAddProduct = () => {
    let AllMandatoryChecked = this.props.productSelected.mealOptions.every(
      mealOption => {
        let exist = true;
        if (mealOption.flagRequired === 'Y') {
          exist = this.state.mealOptions.some(
            mealOptionSelected =>
              mealOptionSelected.idCategoryType === mealOption.idCategoryType
          );
        }
        return exist;
      }
    );
    if (AllMandatoryChecked) {
      let productSelected = {
        id: this.props.productSelected.id,
        name: this.props.productSelected.name,
        description: this.props.productSelected.description,
        price: this.state.total,
        mealOptions: this.state.mealOptions,
      };
      this.props.onAddProductToCart({
        product: productSelected,
        business: this.props.restaurantSelected,
      });
      this.setState(initialState);
      this.props.onCloseProductDetails();
    } else {
      this.setState({
        showModal: true,
        errorMessage: knownError(ERROR_CODES.MENU_OPTIONS_REQUIRED, {
          title: 'Choose the required options',
          message: 'Some sections of this dish need a choice before it can go in your basket.',
          guidance: 'Make a choice in each required section, then add the dish.',
        }),
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleCloseProductDetails = () => {
    this.setState(initialState);
    this.props.onCloseProductDetails();
  };

  render() {
    return this.props.productSelected !== null ? (
      <Aux>
        <ReactModal
          isOpen={true}
          className="content-react-modal"
          style={customStyles}
          onRequestClose={this.handleCloseProductDetails}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          contentLabel="Example Modal"
        >
          <ModalError
            showModal={this.state.showModal}
            errorMessage={this.state.errorMessage}
            closeModal={this.handleCloseModal}
            style={{
              zIndex: '99999999',
              position: 'absolute',
              margin: '1% 25%',
            }}
          />
          <div
            style={{ height: 'inherit' }}
            className="lb-padrao-singup6 mfp-content-login modal-content product-details-content"
            tabIndex={0}
          >
            <button
              onClick={this.handleCloseProductDetails}
              title="Close (Esc)"
              type="button"
              className="mfp-close lb-fechar fa fa-times"
            ></button>
            <article>
              <header tabIndex={0}>
                <h3>{this.props.productSelected.name}</h3>
                <span>
                  By{' '}
                  {this.props.restaurantSelected
                    ? this.props.restaurantSelected.name
                    : this.props.productSelected.businessName}
                </span>
              </header>
              <NutritionFacts
                product={this.props.productSelected}
              ></NutritionFacts>
              <p>{this.props.productSelected.description}</p>
            </article>
            <PickOutOptions
              productSelected={this.props.productSelected}
              selectMealOptions={this.handleSelectMealOptions}
              mealOptionsSelected={this.state.mealOptions}
            />
            <button
              onClick={this.handleClickAddProduct}
              className="orange-bold btn-product-details"
            >
              + Add for{' '}
              {currencyUtils.convertNameToSymbol(
                this.props.restaurantSelected.currency
              ) + this.state.total.toFixed(2)}
            </button>
          </div>
        </ReactModal>
      </Aux>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    productSelected: state.menuReducer.productSelected,
    restaurantSelected: state.menuReducer.restaurantSelected,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCloseProductDetails: () => dispatch(menuActions.closeProductDetails()),
    onAddProductToCart: product =>
      dispatch(menuActions.addProductToCart(product)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/Products/ProductDetails/ProductDetails.js